import { InternalLocale } from '@catawiki/locale';
import {
  Assets,
  AssetsTheme,
  fetchSharedHTMLAssetsOnServerSide,
} from '@catawiki/runtime-toolkit';

import DefaultAsset from '../stubs/defaultAsset.json';

export interface LocalAssets extends Assets {
  error?: unknown;
}

export enum LocalTheme {
  MARKETING = 'marketing',
  PARTNERSHIP = 'partnership',
}

export const PagesTheme = {
  ...AssetsTheme,
  ...LocalTheme,
} as const;
export type PagesTheme = (typeof PagesTheme)[keyof typeof PagesTheme];

const ALLOW_ASSETS_THEME: PagesTheme[] = [
  AssetsTheme.BUYER,
  AssetsTheme.FOCUSED,
];

export async function fetchAssets(
  locale: InternalLocale = InternalLocale.ENGLISH,
  theme: PagesTheme = PagesTheme.BUYER
): Promise<LocalAssets> {
  const localTheme = ALLOW_ASSETS_THEME.includes(theme)
    ? theme
    : AssetsTheme.BUYER;
  const assetsData = await fetchSharedHTMLAssetsOnServerSide(
    process.env.CW_API_ENDPOINT ?? '',
    localTheme as AssetsTheme,
    {
      locale,
      host: process.env.CW_API_HOST ?? '',
      app: process.env.APP_NAME ?? '',
      authToken: process.env.APP_CW_API_AUTH_TOKEN ?? '',
    }
  );
  if (!assetsData.header) {
    return {
      ...DefaultAsset,
      error: 'Fail to load assets',
    };
  }
  return assetsData;
}
